import type { UIMessage, UseChatHelpers } from '@ai-sdk/react';
import { useState, useEffect } from 'react';

import { useScrollToBottom } from './use-scroll-to-bottom';

export function useMessages({ chatUuid, status }: { chatUuid?: string; status: UseChatHelpers<UIMessage>['status'] }) {
  const { containerRef, endRef, isAtBottom, scrollToBottom, onViewportEnter, onViewportLeave } = useScrollToBottom();
  const [hasSentMessage, setHasSentMessage] = useState(false);

  useEffect(() => {
    if (chatUuid) {
      scrollToBottom('instant');
      setHasSentMessage(false);
    }
  }, [chatUuid, scrollToBottom]);

  useEffect(() => {
    if (status === 'submitted') {
      setHasSentMessage(true);
      setTimeout(() => {
        scrollToBottom('smooth');
      }, 500);
    }
  }, [status, scrollToBottom]);

  return {
    containerRef,
    endRef,
    isAtBottom,
    scrollToBottom,
    onViewportEnter,
    onViewportLeave,
    hasSentMessage,
  };
}
